import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

export const useQueryString = <T extends Record<string, any>>(): Partial<T> => {
  const { search } = useLocation();
  const { query } = queryString.parseUrl(search, { parseNumbers: true });

  return query as Partial<T>;
};
